import { render, staticRenderFns } from "./rb.vue?vue&type=template&id=f1a0fb60&scoped=true"
import script from "./rb.vue?vue&type=script&lang=js"
export * from "./rb.vue?vue&type=script&lang=js"
import style0 from "./rb.vue?vue&type=style&index=0&id=f1a0fb60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a0fb60",
  null
  
)

export default component.exports